define('gigaset_recurring/components/checkout/provider/billwerk/payment/method/debit',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/dom/event/trigger",
	"cartware/components/PubSubHub",
	"cartware/jquery/bem"
], function(
	$,
	_,
	Component,
	trigger,
	PubSubHub,
	BEM
) {
	return Component.create({

		$init: function() {
			this.block = BEM.block("gigaset-recurring-payment-method-debit");
			this.form = this.block.getElements("form");

			this.validation = new Validation(this.form.get(0)); // global
		},

		validate: function() {
			return this.validation.validate();
		}
	});
});
